export default function forgotPasswordForm() {
  return {
    formData: {
      emailId: "",
      dateOfBirth: "",
    },
    form: {},
    showSuccessMesage: false,
    message: "",
    successMessage: '',
    errors: {},
    isValidEmail(email) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailPattern.test(email);
    },
    validateForm() {
      this.errors = {};

      if (!this.formData.emailId) {
        this.errors.emailId = "Email id is required.";
      } else if (!this.isValidEmail(this.formData.emailId)) {
        this.errors.emailId = "Please enter valid email.";
      } else {
        delete this.errors["emailId"];
      }

      if (!this.formData.dateOfBirth) {
        this.errors.dateOfBirth = "Date of birth is required.";
      } else {
        delete this.errors["dateOfBirth"];
      }
      return Object.keys(this.errors).length === 0;
    },
    onResetPasswordClick() {
      this.resetPassword = true;
    },
    submitData() {
      if (this.validateForm()) {
        fetch("/api/login/Forgotpassword", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: this.formData.emailId,
            dateOfBirth: this.formData.dateOfBirth,
          }),
        })
          .then((response) => {
            return response.json();
          })
          .then((login) => {
            this.showSuccessMesage = login.isSuccess;
            if (login.isSuccess) {
                // document.location.href = "/set-password?login_id=" + this.formData.emailId + "&passkey=" + login.passKey;
                this.successMessage = 'Forgot password reset link shared successfully. Please check your email.'
            } else {
              this.message = login.message;
            }
          });
      }
    },
  };
}
